<template>
  <div class="materialReservationDetail">
    <ls-card title="预约信息">
      <a-row>
        <ls-info-form :split-number="3">
          <ls-info-item title="预约单号" slot="apptsNo">{{ formData.apptsNo }}</ls-info-item>
          <ls-info-item title="加工厂" slot="organizationName">{{ formData.organizationName }}</ls-info-item>
          <ls-info-item title="原材料商" slot="supplierName">{{ formData.supplierName }}</ls-info-item>
          <ls-info-item title="计划入园时间" slot="fmApptsTime">{{ formData.fmApptsTime }}</ls-info-item>
          <ls-info-item title="计划出园时间" slot="toApptsTime">{{ formData.toApptsTime }}</ls-info-item>
          <ls-info-item title="月台" slot="dockCodeName">{{ formData.dockCodeName }}</ls-info-item>
          <ls-info-item title="送货电梯" slot="deliverLift">{{ formData.deliverLift }}</ls-info-item>
          <ls-info-item title="预约状态" slot="apptsStatusName">{{ formData.apptsStatusName }}</ls-info-item>
          <ls-info-item title="司机姓名" slot="userName">{{ formData.userName }}</ls-info-item>
          <ls-info-item title="司机电话" slot="userTel">{{ formData.userTel }}</ls-info-item>
          <ls-info-item title="车牌号" slot="licenseNo">{{ formData.licenseNo }}</ls-info-item>
          <ls-info-item title="车辆类型" slot="licenseTypeCodeName">{{ formData.licenseTypeCodeName }}</ls-info-item>
          <ls-info-item title="车辆大小" slot="licenseSizeCodeName">{{ formData.licenseSizeCodeName }}</ls-info-item>
          <ls-info-item title="物料类型" slot="materialTypeCodeName">{{ formData.materialTypeCodeName }}</ls-info-item>
          <ls-info-item title="创建人" slot="createUserName">{{ formData.createUserName }}</ls-info-item>
          <ls-info-item title="创建人电话" slot="createUserTel">{{ formData.createUserTel }}</ls-info-item>
          <ls-info-item title="收货工厂" slot="receiveSupplierName">{{ formData.receiveSupplierName }}</ls-info-item>
        </ls-info-form>
      </a-row>
    </ls-card>
    <ls-card title="履约详情">
      <a-row>
        <ls-info-form :split-number="3">
          <ls-info-item title="实际入园时间" slot="arriveTime">{{ formData.arriveTime }}</ls-info-item>
          <ls-info-item title="实际出园时间" slot="leaveTime">{{ formData.leaveTime }}</ls-info-item>
          <ls-info-item title="入园扫码保安" slot="arriveScanUserName">{{ formData.arriveScanUserName }}</ls-info-item>
          <ls-info-item title="出园扫码保安" slot="leaveScanUserName">{{ formData.leaveScanUserName }}</ls-info-item>
          <ls-info-item title="审核时间" slot="auditTime">{{ formData.auditTime }}</ls-info-item>
          <ls-info-item title="驳回备注" slot="remark">{{ formData.remark }}</ls-info-item>
          <ls-info-item title="超时出园" slot="isDelayArriveName">{{ formData.isExpectDelayLeaveName }}</ls-info-item>
        </ls-info-form>
      </a-row>
    </ls-card>
    <ls-card title="卸车照片">
      <div class="image-list">
        <div class="list-item" v-for="(item, index) in formData.picUrlList" :key="index">
          <div class="image-item">
            <ls-image
              :imgStyle="{width:'100%', height:'200px',padding: '8px'}"
              need-down
              :customDownFileName="() => item || ''"
              :src-list="[item]"
              :customOpenShow="customOpenShowFun" />
          </div>
        </div>
      </div>
    </ls-card>
    <ls-card title="送货明细">
      <a-row>
        <a-col style="max-width: 800px;float: left">
          <a-table
            class="table-common"
            :data-source="formData.deliverDetailList"
            :row-key="(record,index) => index"
            :columns="deliverGoodsColumn"
            :scroll="{y:300}"
            :pagination="false"
          />
        </a-col>
      </a-row>
    </ls-card>
    <ls-card title="操作日志">
      <a-row>
        <a-col style="max-width: 800px;float: left">
          <a-table
            :scroll="{y:300}"
            class="table-common"
            :data-source="formData.operatedRecordList"
            :row-key="(record,index) => index"
            :columns="operateColumn"
            :pagination="false"
          />
        </a-col>
      </a-row>
    </ls-card>
    <viewer @inited="viewerText" :images="formData.picUrlList">
      <img v-for="(item, index) in formData.picUrlList" style="display:none" :src="item" :key="item.rowId || ('siteElegancePhoto'+index)" />
    </viewer>
  </div>
</template>

<script>
import { apiGetApptsDetail } from '@/api/scp/materialReservationManagement/materialReservation'

export default {
  name: 'MaterialReservationDetail',
  data () {
    return {
      loading: false,
      formData: {
        picUrlList: [], // 图片链接集合
        deliverDetailList: [], // 送货明细
        operatedRecordList: [] // 操作日志
      },
      deliverGoodsColumn: [
        { title: '单据号', dataIndex: 'subBillCode', width: 180 },
        { title: '件数', dataIndex: 'deliverQuantity', width: 100 },
        { title: '货物描述', dataIndex: 'deliverDescription' }
      ],
      operateColumn: [
        { title: '操作人', dataIndex: 'createName', width: 100, align: 'center' },
        { title: '操作节点', dataIndex: 'operatedDescription' },
        { title: '操作时间', dataIndex: 'createTime', width: 160 }
      ]
    }
  },
  methods: {
    // 获取详情
    initGetDetail() {
      this.formData = {
        picUrlList: [], // 图片链接集合
        deliverDetailList: [], // 送货明细
        operatedRecordList: [] // 操作日志
      }
      apiGetApptsDetail({ apptsNo: this.$route.query?.apptsNo }).then((res) => {
        if (res?.code === 200) {
          this.formData = res.data
        } else {
          this.$message.error(res?.msg || '获取详情失败')
        }
      })
    },
    // 图片查看组件初始化
    viewerText(viewer) {
      this.$viewer = viewer
    },
    // 打开查看图片
    customOpenShowFun(val) {
      const valImg = val?.currentTarget?.dataset?.source;
      if(valImg) {
        const imgIndex = this.formData?.picUrlList?.findIndex(imgItem => imgItem === valImg)
        if(imgIndex !== -1) {
          this.$viewer.index = imgIndex // 定位当前图片
          this.$viewer.show()
        }
      }
    }
  },
  activated() {
    this.initGetDetail()
  },
  created() {
    this.initGetDetail()
  }
}
</script>

<style lang="less" scoped>
.materialReservationDetail{
  padding-bottom: 15px;
}
.image-list{
  display: flex;
  .list-item{
    margin: 10px 15px
  }
}
.image-item{
  width: 190px;
  height: 240px;
  /deep/.image-viewer{
    width: 100%
  }
  /deep/.mask{
    width: 100% !important;
  }
}
.table-common{
  width: 100%;
  /deep/ .ant-table-body{
    overflow-y: auto !important;
  }
}

</style>
